import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import K1LevelAnalyticsView from "@/features/K1Dashboard/views/K1LevelAnalyticsView";

export default function K1LevelAnalytics() {
  useEffect(() => {
    setDocumentTitle("Quantilia | K1 Level");
  }, []);

  return (
    <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
      <K1LevelAnalyticsView />
    </main>
  );
}
